import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegisteredRetailer } from 'src/app/models/registered-retailer.model';
import { RetailerDataStoreService } from 'src/app/service/retailer-data-store.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-dealer-details',
  templateUrl: './view-dealer-details.component.html',
  styleUrls: ['./view-dealer-details.component.scss']
})
export class ViewDealerDetailsComponent implements OnInit {
  dealer: RegisteredRetailer | null = null;
  buttonText: string = 'Edit Details';
  isEditDisabled: boolean = false;

  constructor(
    private router: Router,
    private retailerDataStore: RetailerDataStoreService,
    private location: Location
  ) {
    // Attempt to get the dealer from router state (primary way from list)
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state && navigation.extras.state['dealer']) {
      this.dealer = navigation.extras.state['dealer'] as RegisteredRetailer;
      // Also set it in the store for subsequent steps if needed
      this.retailerDataStore.setRetailer(this.dealer);
      console.log('Dealer data received from router state:', this.dealer);
    } else {
      // If not from router state, try to get from the store (e.g., if page refreshed or deep linked)
      this.dealer = this.retailerDataStore.getRetailer();
      console.log('Dealer data retrieved from store:', this.dealer);
    }
  }

  ngOnInit(): void {
    if (this.dealer) {
      // Check if latitude, longitude, and retailerShopImage have values
      if (this.dealer.latitude && this.dealer.longitude && this.dealer.retailerShopImage) {
        this.buttonText = 'Details Already Captured';
        this.isEditDisabled = true;
      } else {
        this.buttonText = 'Edit Details';
        this.isEditDisabled = false;
      }
    } else {
      // Handle case where no dealer data was passed (e.g., direct access)
      this.router.navigate(['/dealers']); // Redirect back to list
    }
  }

  goBack(): void {
    this.retailerDataStore.clearCapturedImageFile();
    this.retailerDataStore.clearRetailer();
    this.location.back();
  }

  editDetails(): void {
    if (this.dealer && !this.isEditDisabled) {
      // Navigate to the generate-otp screen
      // Pass the primary mobile number as a query param, and a flag to indicate it's an edit flow
      this.router.navigate(['/add-dealer-phone'], {
        queryParams: {
          primaryMobile: this.dealer.mobileNumberPrimary,
          isEditFlow: true // This flag tells generate-otp to disable input
        }
      });
    }
  }
}